import { getCachedPost, getCachedRootPost, useAuthMember, } from '@tribeplatform/react-sdk/hooks';
import { useQueryClient } from '@tribeplatform/react-sdk/lib';
import { getPostsKey } from '@tribeplatform/react-sdk/utils/keys';
const gatherMentionsFromPost = (_post, mentions = {}) => {
    var _a, _b, _c, _d;
    const author = ((_a = _post === null || _post === void 0 ? void 0 : _post.createdBy) === null || _a === void 0 ? void 0 : _a.member) || ((_b = _post === null || _post === void 0 ? void 0 : _post.owner) === null || _b === void 0 ? void 0 : _b.member);
    if (!author)
        return;
    mentions[author.id] = {
        id: author.id,
        title: author.name,
        icon: (_c = author.profilePicture) === null || _c === void 0 ? void 0 : _c.url,
    };
    (_d = _post.mentions) === null || _d === void 0 ? void 0 : _d.forEach(m => {
        var _a;
        mentions[m.id] = {
            id: m.id,
            title: m.name,
            icon: (_a = m.profilePicture) === null || _a === void 0 ? void 0 : _a.id,
        };
    });
};
const gatherMentionsFromPaginatedPosts = (page, mentions = {}) => {
    try {
        if (page === null || page === void 0 ? void 0 : page.edges) {
            page.edges.forEach(edge => {
                if (edge === null || edge === void 0 ? void 0 : edge.node) {
                    gatherMentionsFromPost(edge.node, mentions);
                    if (edge.node.replies) {
                        gatherMentionsFromPaginatedPosts(edge.node.replies, mentions);
                    }
                }
            });
        }
        else if (page === null || page === void 0 ? void 0 : page.nodes) {
            page.nodes.forEach(node => {
                if (node) {
                    gatherMentionsFromPost(node, mentions);
                    if (node === null || node === void 0 ? void 0 : node.replies) {
                        gatherMentionsFromPaginatedPosts(node.replies, mentions);
                    }
                }
            });
        }
    }
    catch (e) {
        console.error('could not gather mentions from paginated post', e);
    }
};
const gatherMentionsFromInfinitePaginatedPosts = (paginatedPosts, mentions = {}) => {
    var _a, _b;
    try {
        if (!((_b = (_a = paginatedPosts === null || paginatedPosts === void 0 ? void 0 : paginatedPosts.pages) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.totalCount)) {
            return;
        }
        paginatedPosts.pages.forEach(page => gatherMentionsFromPaginatedPosts(page, mentions));
    }
    catch (e) {
        console.error('could not gather mentions from infinite paginated post', e);
    }
};
export const useCachedMentionsFromPost = (postId, options) => {
    const { enabled } = options;
    const { data: authMember } = useAuthMember();
    const queryClient = useQueryClient();
    if (!postId || !enabled)
        return;
    const mentionsMap = {};
    // get the post and post.replies
    const cachedPost = getCachedPost(postId, queryClient);
    gatherMentionsFromPost(cachedPost, mentionsMap);
    if (cachedPost === null || cachedPost === void 0 ? void 0 : cachedPost.replies) {
        gatherMentionsFromPaginatedPosts(cachedPost.replies, mentionsMap);
    }
    // find root parent
    const cachedRootPost = getCachedRootPost(postId, queryClient);
    if (cachedRootPost && cachedRootPost.id !== postId) {
        gatherMentionsFromPost(cachedRootPost, mentionsMap);
    }
    // find replies
    const cachedReplies = queryClient.getQueriesData({
        active: true,
        predicate: query => {
            const { queryKey } = query;
            if (Array.isArray(queryKey)) {
                const [main, args] = queryKey || [];
                return main === getPostsKey()[0] && args.variables.postId === postId;
            }
            return false;
        },
    });
    cachedReplies.forEach(data => {
        gatherMentionsFromInfinitePaginatedPosts(data[1], mentionsMap);
    });
    // we should not display the user itself
    if (mentionsMap[authMember.id]) {
        delete mentionsMap[authMember.id];
    }
    return Array.from(Object.values(mentionsMap));
};
//# sourceMappingURL=useCachedMentionsFromPost.js.map